module.exports = require("../d") + require("./dupdep");


/*****************
 ** WEBPACK FOOTER
 ** ./compile/deduplication/dedupe1/index.js
 ** module id = 1
 ** module chunks = 0
 **/